import moment from "moment";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal, ModalBody, Table } from "reactstrap";
import { Switch } from "antd";
import { IoCloseSharp } from "react-icons/io5";
import { FiImage } from "react-icons/fi";
import logo from "../../assets/imgs/pdf-logo.png";
import GeneralButton from "../button/GeneralButton";

const PdfSlipModal = ({ modal, toggle, selectedItems, state, showLogo = true, setShowLogo }) => {
  const [internalShowLogo, setInternalShowLogo] = useState(true);
  const isLogoVisible = setShowLogo ? showLogo : internalShowLogo;
  const toggleLogo = (val) => {
    if (setShowLogo) {
      setShowLogo(val);
    } else {
      setInternalShowLogo(val);
    }
  };

  const printSectionRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: printSectionRef,
    documentTitle: `Packing_Slip_${state?.id || "order"}`,
    pageStyle: `
      @page {
        size: letter portrait;
        margin: 6mm 8mm !important;
      }
      @media print {
        html, body {
          width: 100% !important;
          height: auto !important;
          margin: 0 !important;
          padding: 0 !important;
          background: #fff !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `,
  });

  const getQuantity = (sku, index) => {
    let totalQuantity = 0;
    const item = [...selectedItems];
    item[index]?.labels?.forEach((label) => {
      totalQuantity += label.quantity || 0;
    });
    return totalQuantity;
  };

  const thStyle = { backgroundColor: "#f0f0f0", color: "#000", borderBottom: "1px solid #dee2e6", fontSize: "12px", fontWeight: "700" };

  return (
    <Modal isOpen={modal} toggle={toggle} centered size="xl" style={{ maxWidth: "1200px" }}>
      <ModalBody className="p-4" style={{ backgroundColor: "#f8f9fa", overflowX: "auto" }}>
        {/* Top Header */}
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <h5 className="m-0 fw-bold" style={{ color: "#1a1a2e" }}>Packing Slip Preview</h5>
          <IoCloseSharp
            size={26}
            onClick={toggle}
            className="pointer"
            style={{ cursor: "pointer", color: "#6b7280" }}
          />
        </div>
        <div className="d-flex justify-content-center w-100">
          <section
            ref={printSectionRef}
            className="p-4 bg-white shadow-sm pdf-container"
            style={{ width: "1000px", minWidth: "1000px", color: "#333", fontSize: "13px", border: "1px solid #dee2e6", margin: "0 auto" }}
          >
            <style>
              {`
                .invoice-card {
                  background-color: #fff;
                  border: 1px solid #dee2e6;
                  border-radius: 4px;
                  overflow: hidden;
                }
                .invoice-card-header {
                  background-color: #f0f0f0;
                  color: #000;
                  font-weight: 700;
                  font-size: 12px;
                  letter-spacing: 0.5px;
                  padding: 6px 12px;
                  text-transform: uppercase;
                  border-bottom: 1px solid #dee2e6;
                }
                .invoice-card-body {
                  padding: 10px 14px;
                  font-size: 13px;
                  line-height: 1.45;
                }
                .invoice-card-body p {
                  margin-bottom: 2px;
                }
                .info-row {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 4px 0;
                  border-bottom: 1px solid #dee2e6;
                  font-size: 13px;
                }
                .info-row:last-child {
                  border-bottom: none;
                  padding-bottom: 0;
                }

                @media print {
                  @page {
                    size: letter portrait;
                    margin: 6mm 8mm !important;
                  }
                  html, body {
                    width: 100% !important;
                    height: auto !important;
                    background: #fff !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                  }
                  .pdf-container {
                    width: 100% !important;
                    min-width: 100% !important;
                    max-width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    border: none !important;
                    box-shadow: none !important;
                    font-size: 11.5px !important;
                    line-height: 1.35 !important;
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
                  .pdf-container * {
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                  }
                  .row-2-col {
                    display: flex !important;
                    flex-direction: row !important;
                    width: 100% !important;
                    gap: 14px !important;
                    margin-bottom: 14px !important;
                  }
                  .col-half {
                    width: 50% !important;
                    flex: 1 1 50% !important;
                  }
                  .invoice-card-header {
                    font-size: 11px !important;
                    padding: 5px 10px !important;
                    background-color: #f0f0f0 !important;
                  }
                  .invoice-card-body {
                    padding: 8px 12px !important;
                    font-size: 11.5px !important;
                  }
                  .invoice-card-body p {
                    margin-bottom: 2px !important;
                    font-size: 11.5px !important;
                  }
                  .info-row {
                    padding: 3px 0 !important;
                    font-size: 11.5px !important;
                  }
                  .packing-table th {
                    font-size: 10.5px !important;
                    padding: 5px 8px !important;
                    background-color: #f0f0f0 !important;
                  }
                  .packing-table td {
                    font-size: 11px !important;
                    padding: 6px 8px !important;
                  }
                  table {
                    page-break-inside: avoid !important;
                    width: 100% !important;
                  }
                  tr {
                    page-break-inside: avoid !important;
                  }
                  thead {
                    display: table-header-group !important;
                  }
                  .no-print {
                    display: none !important;
                  }
                }
              `}
            </style>

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
              {isLogoVisible ? (
                <img src={logo} style={{ height: "auto", maxWidth: "220px" }} alt="Tech Micro USA" />
              ) : (
                <div style={{ minHeight: "45px" }} />
              )}
              <div className="text-end">
                <h2 className="mb-0 fw-bold" style={{ color: "#1a3b5c", letterSpacing: "1px", textTransform: "uppercase", fontSize: "26px" }}>PACKING SLIP</h2>
                <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>Date: {moment(state?.date_created || Date.now()).format("MMM DD, YYYY")}</p>
                <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>Order No: {state?.id ?? "Not Available"}</p>
              </div>
            </div>

            {/* Row 1: From & Order Details */}
            <div className="row-2-col mb-3" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "14px" }}>
              <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
                <div className="invoice-card h-100">
                  <div className="invoice-card-header">FROM</div>
                  <div className="invoice-card-body">
                    <p className="fw-bold text-dark">TechMicro USA</p>
                    <p>206 Far Hills Drive</p>
                    <p>Bolingbrook, IL 60440</p>
                    <p>Sales No: (630) 526 1800</p>
                    <p className="mb-0">www.techmicrousa.com</p>
                  </div>
                </div>
              </div>
              <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
                <div className="invoice-card h-100">
                  <div className="invoice-card-header">ORDER DETAILS</div>
                  <div className="invoice-card-body">
                    <div className="info-row">
                      <span className="fw-bold">Order No</span>
                      <span>{state?.id ?? "Not Available"}</span>
                    </div>
                    <div className="info-row">
                      <span className="fw-bold">Customer PO</span>
                      <span>{state?.customer_po || state?.customerPo || (state?.number && state?.po_no ? `${state.number} - ${state.po_no}` : (state?.number || state?.po_no || "N/A"))}</span>
                    </div>
                    <div className="info-row">
                      <span className="fw-bold">Ship By</span>
                      <span>{state?.shipping_lines?.[0]?.method_title || state?.shipBy || state?.shippingVia || state?.shipping_via || "Ground 5 - 7 Days"}</span>
                    </div>
                    {state?.online && (
                      <div className="info-row">
                        <span className="fw-bold">Shipping Carrier</span>
                        <span>{state?.shipping_carrier ?? "Not Available"}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Row 2: Bill To & Ship To */}
            <div className="row-2-col mb-3" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "14px" }}>
              <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
                <div className="invoice-card h-100">
                  <div className="invoice-card-header">BILL TO</div>
                  <div className="invoice-card-body">
                    <p className="fw-bold text-dark">{state?.billing?.company ?? "Not Available"}</p>
                    <p>{`${state?.billing?.first_name ?? ""} ${state?.billing?.last_name ?? ""}`}</p>
                    <p>{state?.billing?.address_1 ?? ""}</p>
                    {state?.billing?.address_2 && <p>{state?.billing?.address_2}</p>}
                    <p>{`${state?.billing?.city ?? ""}, ${state?.billing?.state ?? ""} ${state?.billing?.postcode ?? ""}`}</p>
                    <p>Ph: {state?.billing?.phone ?? "Not Available"}</p>
                    {state?.billing?.email && <p className="mb-0">Email: {state?.billing?.email}</p>}
                  </div>
                </div>
              </div>
              <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
                <div className="invoice-card h-100">
                  <div className="invoice-card-header">SHIP TO</div>
                  <div className="invoice-card-body">
                    <p className="fw-bold text-dark">{state?.shipping?.company ?? "Not Available"}</p>
                    <p>{`${state?.shipping?.first_name ?? ""} ${state?.shipping?.last_name ?? ""}`}</p>
                    <p>{state?.shipping?.address_1 ?? ""}</p>
                    {state?.shipping?.address_2 && <p>{state?.shipping?.address_2}</p>}
                    <p>{`${state?.shipping?.city ?? ""}, ${state?.shipping?.state ?? ""} ${state?.shipping?.postcode ?? ""}`}</p>
                    <p>Ph: {state?.shipping?.phone ?? "Not Available"}</p>
                    {state?.shipping?.email && <p className="mb-0">Email: {state?.shipping?.email}</p>}
                  </div>
                </div>
              </div>
            </div>

            {/* Product Table */}
            <Table bordered hover className="text-center shadow-sm mb-0 packing-table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr className="text-uppercase" style={{ fontSize: "12px" }}>
                  <th style={thStyle}>SKU</th>
                  <th style={thStyle} className="text-start">Description</th>
                  <th style={thStyle}>Weight</th>
                  <th style={thStyle}>Part No.</th>
                  <th style={thStyle}>Qty Shipping</th>
                  <th style={thStyle}>Back Order</th>
                  <th style={thStyle}>Already Shipped</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "12.5px" }}>
                {selectedItems?.map((row, index) => (
                  <tr key={index} className="align-middle">
                    <td className="fw-semibold" style={{ wordBreak: "break-all" }}>{row?.sku}</td>
                    <td className="text-start" style={{ wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                      {row?.description?.replace(/<br\s*\/?>/gi, " ")?.replace(/<[^>]+>/g, "") ?? "Not Available"}
                    </td>
                    <td>{row?.weight ? `${row.weight} lbs` : "0 lbs"}</td>
                    <td style={{ wordBreak: "break-all" }}>{row?.sku?.slice(4) ?? "Not Available"}</td>
                    <td className="text-success fw-bold">
                      {row?.newQuantity ?? row?.quantity}
                    </td>
                    <td className="text-danger fw-bold">
                      {(row?.quantity ?? 0) - (row?.newQuantity ?? 0)}
                    </td>
                    <td className="text-dark fw-bold">
                      {getQuantity(row?.sku, index)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </section>
        </div>

        {/* Action Buttons */}
        <div className="d-flex justify-content-between align-items-center pb-2 pe-4 ps-2 mt-3">
          <div
            className="d-flex align-items-center gap-2 px-3 py-1 bg-white rounded-pill border shadow-sm"
            style={{ fontSize: "13px" }}
          >
            <FiImage size={15} className={isLogoVisible ? "text-primary" : "text-muted"} />
            <span className="fw-semibold" style={{ color: isLogoVisible ? "#1e293b" : "#64748b" }}>
              Include Logo:
            </span>
            <Switch
              checked={isLogoVisible}
              onChange={toggleLogo}
              size="small"
              checkedChildren="ON"
              unCheckedChildren="OFF"
            />
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary px-3 py-2 fw-semibold"
              style={{ fontSize: "14px", borderRadius: "6px" }}
              onClick={toggle}
            >
              Close
            </button>
            <GeneralButton
              title="Print / Save as PDF"
              className="blue-button"
              width="200px"
              handleClick={() => handlePrint()}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PdfSlipModal;
